export default __webpack_public_path__ + "static/media/ren-logo.1afba112.png";